import { useMemo } from 'react';

import { Cart, PeerTypes, StoreItem } from '@givebacks/api/store';

type UseIsCartPledgeRequired = {
  itemType?: StoreItem['__type'];
  peerType?: PeerTypes | null;
  hasCredits: boolean;
  isPledge: boolean;
};

const useIsCartPledgeRequired = ({
  itemType,
  peerType,
  hasCredits,
  isPledge,
}: UseIsCartPledgeRequired) => {
  const cartStatus: Cart['status'] | undefined = useMemo(() => {
    const isPledgeReq = itemType == 'athon' && peerType === 'participants' && hasCredits;
    return isPledgeReq && isPledge ? 'pledge_required' : undefined;
  }, [hasCredits, isPledge, itemType, peerType]);
  return { cartStatus };
};

export { useIsCartPledgeRequired };
